import React from 'react';

const row = (selected, dimmed) => ({
  padding: '10px 12px',
  border: '1px solid #e2e8f0',
  borderRadius: 10,
  background: selected ? '#eef7ff' : '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  opacity: dimmed ? 0.45 : 1,
  filter: dimmed ? 'grayscale(60%)' : 'none',
});

const btn = {
  padding: '4px 8px',
  borderRadius: 6,
  border: '1px solid rgba(255, 0, 0, 1)',
  background: 'rgba(255, 0, 0, 1)',
  color: '#fff',
  fontSize: 12,
};
const badge = {
  fontSize: 10,
  padding: "2px 6px",
  borderRadius: 999,
  background: "#eee",
  color: "#666",
  marginLeft: 8,
  border: "1px solid #ddd",
};
export default function SubcategoryList({ subcategories = [], selectedSubcategoryId, onSelect, onEdit }) {
  return (
    <div className="menu-manager-list" style={{ display: 'flex', flexDirection: 'column', gap: 8 ,  maxHeight: '75vh',overflowY: 'auto'}}>
      {subcategories.map(sc => {
        const vis = sc.visibility ?? sc.visibilty;
        const dimmed =
          vis === 0 || vis === '0' || vis === false || vis === 'False';

        const selected = String(sc.id) === String(selectedSubcategoryId);

        return (
          <div
            key={sc.id}
            style={row(selected, dimmed)}
            onClick={() => onSelect?.(sc)}
            title={dimmed ? 'Hidden subcategory' : undefined}
          >
            <div>
              <div style={{ fontWeight: 600 }}>{sc.name} {dimmed && <span style={badge}>Hidden</span>}</div>
              <div style={{ fontSize: 12, color: '#666' }}>
                subcode: {sc.subcode ?? sc.id} {dimmed ? " - Hidden From App Menu" : ""}
              </div>
            </div>
            <button
              type="button"
              style={dimmed ? { ...btn,  } : btn}
              onClick={(e) => { e.stopPropagation(); onEdit?.(sc); }}
              aria-disabled={dimmed}
              // If you want to block edits entirely when hidden:
              // disabled={dimmed}
            >
              Edit
            </button>
          </div>
        );
      })}
      {subcategories.length === 0 && <div style={{ color: '#777' }}>No subcategories.</div>}
    </div>
  );
}
